var React = require('react');

function ToTopArrowInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"opacity":"0.25","fillRule":"evenodd","clipRule":"evenodd","d":"M30.2071 19.7071L36 25.5L35.2929 26.2071L30 20.9142L30 38H29L29 20.9142L23.7071 26.2071L23 25.5L28.7929 19.7071L28.7929 19.7071L29.5 19L29.5 19L30.2071 19.7071Z","fill":"#F9F8F2"}));
}

ToTopArrowInline.defaultProps = {"viewBox":"0 0 59 59","fill":"none"};

module.exports = ToTopArrowInline;

ToTopArrowInline.default = ToTopArrowInline;
